// Map API prospect payload → our form shape
const prefillFromProspect = (api) => {
  if (!api || !api.prospectData) return null;
  const p = api.prospectData;
  const bi = p.businessInfo || {};
  const b1 = (p.basicInfo && p.basicInfo.firstPersonContact) || {};
  const loc = (p.basicInfo && p.basicInfo.location) || {};

  // Address (GST address preferred)
  const addr = bi.addressGST || {};

  return {
    // TEXT fields (we keep the { code } contract)
    name1: { code: bi.dealershipName || "" },
    contact_person: { code: b1.name || "" },
    phone_number: { code: String(bi.phoneNumber || b1.phoneNumber || "") },
    mobile_phone: { code: String(bi.phoneNumber || "") },
    telephone: { code: bi.landline ? String(bi.landline) : "" },
    email: { code: bi.email || b1.email || "" },
    pan: { code: bi.panCard || b1.panNo || "" },
    gst_number: { code: bi.gstin || "" },

    // Address lines
    street_house_no: { code: addr.streetNumber || "" },
    street2: { code: addr.address2 || "" },
    street3: { code: addr.address3 || "" },
    district: { code: addr.districtName || "" },
    city: { code: addr.districtName || "" },
    state: { code: addr.state || "" }, // NOTE: state dropdown exists too; here we just seed text field counterpart
    postal_code: { code: addr.pincode || "" },
    address: { code: [addr.streetNumber, addr.address2, addr.address3, addr.districtName, addr.state, addr.pincode].filter(Boolean).join(", ") },

    // Geo
    latitude: { code: loc.lat || "" },
    longitude: { code: loc.long || "" },

    // Optional commercial defaults
    customer_segment: { code: bi.dealerPotentialCategory || "" },
  };
};
import React, { useState, useEffect, useMemo } from "react";
// import { useLocation, useHistory } from "react-router-dom";
// Safe fallback for reading navigation state without Router hooks
const getNavigationState = () => {
  if (typeof window === "undefined") return null;
  const st = window.history && window.history.state;
  return st?.usr || st?.state || null;
};

// Helper to derive dealerId from multiple sources
const getDealerId = () => {
  try {
    const st = getNavigationState();
    const fromState = st?.dealerId || st?.dealer_id || null;
    const fromQuery = typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('dealerId') : null;
    const fromStorage = typeof window !== 'undefined' ? window.localStorage.getItem('dealerId') : null;
    return fromState || fromQuery || fromStorage || null;
  } catch (_) {
    return null;
  }
};

// Helper: read auth token from localStorage
const getAuthToken = () => {
  try {
    if (typeof window === "undefined") return null;
    // primary key 'token', fallbacks if your app uses different keys
    return (
      window.localStorage.getItem("token") ||
      window.localStorage.getItem("authToken") ||
      window.localStorage.getItem("jwt") ||
      null
    );
  } catch (_) {
    return null;
  }
};
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
  Container,
  Grid,
  ListSubheader,
  Divider,
  Stack,
} from "@mui/material";
import { toastMessage } from "utils/toastMessage";
import { getDealerData } from "_controllers/officer";
import { PageHeader, SectionCard } from "_shared/ui";

const initialFormData = {
  // DROPDOWNS → { id, code, label }
  customer_group: { id: null, code: "", label: "" },
  customer_pricing_procedure: { id: null, code: "", label: "" },
  terms_of_payment: { id: null, code: "", label: "" },
  incoterms: { id: null, code: "", label: "" },
  account_assignment_group: { id: null, code: "", label: "" },
  reconciliation_account: { id: null, code: "", label: "" },
  account_group: { id: null, code: "", label: "" },
  sales_office: { id: null, code: "", label: "" },
  distribution_channel: { id: null, code: "", label: "" },
  division: { id: null, code: "", label: "" },
  state: { id: null, code: "", label: "" },
  customer_class: { id: null, code: "", label: "" },
  status: { id: null, code: "", label: "" },
  price_group: { id: null, code: "", label: "" },
  price_list: { id: null, code: "", label: "" },

  // TEXT → { code }
  company_code: { code: "" },
  sales_org: { code: "" },
  with_sas: { code: "" },
  title: { code: "" },

  name1: { code: "" },
  street_house_no: { code: "" },
  care_of: { code: "" },
  street2: { code: "" },
  street3: { code: "" },
  street5: { code: "" },
  region: { code: "" },
  district: { code: "" },
  different_city: { code: "" },
  mobile_phone: { code: "" },
  telephone: { code: "" },
  fax: { code: "" },
  tax_number_3: { code: "" },
  pan: { code: "" },

  customer_statistic_group: { code: "" },
  delivering_plant: { code: "" },
  rebate: { code: "" },
  gst_non_gst: { code: "" },
  incoterms1: { code: "" },
  customer_segment: { code: "" },
  credit_limit: { code: "" },
  payment_terms: { code: "" },
  delivery_priority: { code: "" },
  tax_classification: { code: "" },
  language: { code: "" },
  sales_district: { code: "" },
  sales_group: { code: "" },
  price_list_group: { code: "" },
  incoterm_location: { code: "" },
  billing_block: { code: "" },
  shipping_condition: { code: "" },
  customer_status: { code: "" },
  account_manager: { code: "" },
  sales_channel: { code: "" },
  distribution_method: { code: "" },
  gst_number: { code: "" },
  ninnumber: { code: "" },
  latitude: { code: "" },
  longitude: { code: "" },
  city: { code: "" },
  postal_code: { code: "" },
  country: { code: "" },
  contact_person: { code: "" },
  phone_number: { code: "" },
  email: { code: "" },
  address: { code: "" },
};

const brandData = {
  "Tyre-Group-1": ["SW", "AW"],
  "Tyre-Group-2": ["12", "13"],
};

// Select that emits { id, code, label }, selects by _id
const SelectField = ({ label, fieldKey, options = [], value, onChange }) => (
  <FormControl fullWidth margin="normal" size="small">
    <InputLabel>{label}</InputLabel>
    <Select
      value={value?.id || ""}
      label={label}
      onChange={(e) => {
        const opt = options?.find(
          (o) => String(o._id) === String(e.target.value)
        );
        onChange(
          fieldKey,
          opt
            ? {
                id: opt._id,
                code: opt.code || "",
                label: opt.description || opt.name || "",
              }
            : { id: null, code: "", label: "" }
        );
      }}
    >
      {options?.map((item) => (
        <MenuItem key={item._id || item.code} value={item._id || ""}>
          {item.description || item.name || ""}{" "}
          {item.code ? `(${item.code})` : ""}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);

const TextFieldInput = ({
  label,
  fieldKey,
  value,
  onChange,
  type = "text",
}) => (
  <TextField
    fullWidth
    margin="normal"
    size="small"
    label={label}
    type={type}
    value={value}
    onChange={(e) => onChange(fieldKey, e.target.value)}
  />
);

const SectionTitle = ({ children }) => (
  <Box sx={{ mt: 3 }}>
    <Typography variant="h6" sx={{ fontWeight: 600 }} gutterBottom>
      {children}
    </Typography>
    <Divider sx={{ mb: 2 }} />
  </Box>
);

const TyreBrandSelector = ({ selectedTyreGroups, onSelect }) => {
  return (
    <FormControl fullWidth margin="normal" size="small">
      <InputLabel>Tyre Brand</InputLabel>
      <Select
        value=""
        onChange={(e) => {
          const [group, value] = e.target.value.split("::");
          onSelect(group, value);
        }}
        displayEmpty
      >
        <ListSubheader>Tyre-Group-1</ListSubheader>
        {brandData["Tyre-Group-1"].map((item) => (
          <MenuItem key={item} value={`Tyre-Group-1::${item}`}>
            {item}
          </MenuItem>
        ))}

        <ListSubheader>Tyre-Group-2</ListSubheader>
        {brandData["Tyre-Group-2"].map((item) => (
          <MenuItem key={item} value={`Tyre-Group-2::${item}`}>
            {item}
          </MenuItem>
        ))}
      </Select>

      <Typography variant="body2" mt={2}>
        Group 1 Selected: {selectedTyreGroups["Tyre-Group-1"] || "None"}
        <br />
        Group 2 Selected: {selectedTyreGroups["Tyre-Group-2"] || "None"}
      </Typography>
    </FormControl>
  );
};

const DealerForm = () => {
  const [formData, setFormData] = useState(initialFormData);
  const [masterData, setMasterData] = useState({});
  const [selectedTyreGroups, setSelectedTyreGroups] = useState({
    "Tyre-Group-1": "",
    "Tyre-Group-2": "",
  });

  // Get prospect data from navigation state
  const prospectData = getNavigationState();
  const dealerId = getDealerId();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getDealerData();
        console.log("res", res);
        if (res?.message === "Onboarding Data") {
          setMasterData(res?.data[0]);
        } else {
          toastMessage(res?.message, "error");
        }
      } catch (err) {
        toastMessage("Failed to fetch master data", "error");
        console.error("API error", err);
      }
    };

    fetchData();
  }, []);

  // Resolve prospectId once and keep it stable for deps
  const prospectId = useMemo(() => {
    const st = getNavigationState();
    return (st?.prospectId) || dealerId || null;
  }, [dealerId]);

  // Prefill from Prospect (by prospectId)
  useEffect(() => {
    if (!prospectId) return;

    const URL = `https://jk-msfa-dev-api.jktyre.co.in/api/v1/prospect/dealerOnboarding/getIndividualProspectData?ID=${prospectId}`;

    let cancelled = false;
    (async () => {
      try {
        const token = getAuthToken();
        if (!token) throw new Error("Missing auth token");
        const res = await fetch(URL, {
          headers: {
            "Authorization": `Bearer ${token}`,
            "Accept": "application/json"
          }
        });
        if (!res.ok) throw new Error(`Failed to fetch prospect: ${res.status}`);
        const data = await res.json();
        const mapped = prefillFromProspect(data);
        if (mapped && !cancelled) {
          setFormData((prev) => ({
            ...prev,
            ...Object.entries(mapped).reduce((acc, [k, v]) => {
              if (prev[k] && typeof prev[k] === 'object' && 'code' in prev[k]) {
                acc[k] = { ...prev[k], ...v };
              } else {
                acc[k] = v;
              }
              return acc;
            }, {}),
          }));
          toastMessage("Prefilled from Prospect", "success");
        }
      } catch (e) {
        if (!cancelled) {
          console.error(e);
          const msg = String(e?.message || "")
            .toLowerCase()
            .includes("missing auth token")
            ? "Auth token missing. Please login again."
            : "Could not prefill prospect data";
          toastMessage(msg, "error");
        }
      }
    })();

    return () => { cancelled = true; };
  }, [prospectId]);

  // Accept object for Selects, string for TextFields
  const handleFieldChange = (fieldKey, value) => {
    setFormData((prev) => ({
      ...prev,
      [fieldKey]:
        value && typeof value === "object"
          ? value // { id, code, label }
          : { ...(prev[fieldKey] || {}), code: value }, // text inputs: keep { code }
    }));
  };

  const handleTyreGroupSelect = (group, value) => {
    setSelectedTyreGroups((prev) => ({
      ...prev,
      [group]: value,
    }));
  };

  const handleSubmit = async () => {
    try {
      const token = getAuthToken();
      if (!token) {
        toastMessage("Auth token missing. Please login again.", "error");
        return;
      }

      // Prepare payload for backend
      const submissionData = {
        dealerId: prospectId || dealerId || null,
        ...formData,
        // ensure prospectData carries prospectId consistently
        prospectData: {
          ...(prospectData || {}),
          prospectId: prospectId || prospectData?.prospectId || null,
          from: (prospectData && prospectData.from) || "prospect_table",
        },
      };

      // Remove tyre data, not required
      const payload = { ...submissionData };
      // selectedTyreGroups not needed currently
      if (payload.selectedTyreGroups) delete payload.selectedTyreGroups;

      // POST to API
      // const res = await fetch(
      //   "http://localhost:8020/api/v1/prospect/createOnBoard",
      //   {
      //     method: "POST",
      //     headers: {
      //       "Content-Type": "application/json",
      //       Authorization: `Bearer ${token}`,
      //     },
      //     body: JSON.stringify(payload),
      //   }
      // );

      const data = await res.json().catch(() => ({}));
      if (!res.ok || data?.status !== "success") {
        const msg = data?.message || `Failed to save (HTTP ${res.status})`;
        toastMessage(msg, "error");
        return;
      }

      toastMessage("Onboarding saved successfully", "success");
      console.log("Saved onboarding:", data?.data);
      // TODO: navigate to detail or list page if needed
    } catch (e) {
      console.error(e);
      toastMessage("Something went wrong while saving", "error");
    }
  };

  const handleCancel = () => {
    window.history.back();
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <PageHeader
        title="Add Customer"
        subtitle="Complete the dealer onboarding details below"
      />
      <SectionCard>
        {prospectData && (
          <Box sx={{ mb: 3, p: 2, bgcolor: "action.hover" }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 700 }}>
              Prospect Information
            </Typography>
            <Typography variant="body2" color="text.secondary">
              From: {prospectData.from}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Prospect ID: {prospectData.prospectId}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Dealer ID: {dealerId || "—"}
            </Typography>
          </Box>
        )}

        <Grid container spacing={3}>
          {/* SAP & Pricing Section */}
          <Grid item xs={12}>
            <SectionTitle>SAP &amp; Pricing</SectionTitle>
          </Grid>
          {/* Customer Group */}
          <Grid item xs={12} md={6}>
            <SelectField
              label="Customer Group"
              fieldKey="customer_group"
              options={masterData.customer_group}
              value={formData.customer_group}
              onChange={handleFieldChange}
            />
          </Grid>

          {/* Customer Pricing Procedure */}
          <Grid item xs={12} md={6}>
            <SelectField
              label="Customer Pricing Procedure"
              fieldKey="customer_pricing_procedure"
              options={masterData.customer_pricing_procedure}
              value={formData.customer_pricing_procedure}
              onChange={handleFieldChange}
            />
          </Grid>

          {/* Terms of Payment */}
          <Grid item xs={12} md={6}>
            <SelectField
              label="Terms of Payment"
              fieldKey="terms_of_payment"
              options={masterData.terms_of_payment}
              value={formData.terms_of_payment}
              onChange={handleFieldChange}
            />
          </Grid>

          {/* Incoterms */}
          <Grid item xs={12} md={6}>
            <SelectField
              label="Incoterms"
              fieldKey="incoterms"
              options={masterData.incoterms}
              value={formData.incoterms}
              onChange={handleFieldChange}
            />
          </Grid>

          {/* Account Assignment Group */}
          <Grid item xs={12} md={6}>
            <SelectField
              label="Account Assignment Group"
              fieldKey="account_assignment_group"
              options={masterData.account_assignment_group}
              value={formData.account_assignment_group}
              onChange={handleFieldChange}
            />
          </Grid>

          {/* Reconciliation Account */}
          <Grid item xs={12} md={6}>
            <SelectField
              label="Reconciliation Account"
              fieldKey="reconciliation_account"
              options={masterData.reconciliation_account}
              value={formData.reconciliation_account}
              onChange={handleFieldChange}
            />
          </Grid>

          {/* Org Structure Section */}
          <Grid item xs={12}>
            <SectionTitle>Org Structure</SectionTitle>
          </Grid>
          {/* Account Group */}
          <Grid item xs={12} md={6}>
            <SelectField
              label="Account Group"
              fieldKey="account_group"
              options={masterData.account_group}
              value={formData.account_group}
              onChange={handleFieldChange}
            />
          </Grid>
          {/* Company Code */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Company Code"
              fieldKey="company_code"
              value={formData.company_code.code}
              onChange={handleFieldChange}
            />
          </Grid>
          {/* Sales Org */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Sales Org"
              fieldKey="sales_org"
              value={formData.sales_org.code}
              onChange={handleFieldChange}
            />
          </Grid>

          {/* Sales Office */}
          <Grid item xs={12} md={6}>
            <SelectField
              label="Sales Office"
              fieldKey="sales_office"
              options={masterData.sales_office}
              value={formData.sales_office}
              onChange={handleFieldChange}
            />
          </Grid>

          {/* Distribution Channel */}
          <Grid item xs={12} md={6}>
            <SelectField
              label="Distribution Channel"
              fieldKey="distribution_channel"
              options={masterData.distribution_channel}
              value={formData.distribution_channel}
              onChange={handleFieldChange}
            />
          </Grid>
          {/* With SAS */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="With SAS"
              fieldKey="with_sas"
              value={formData.with_sas.code}
              onChange={handleFieldChange}
            />
          </Grid>
          {/* Title */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Title"
              fieldKey="title"
              value={formData.title.code}
              onChange={handleFieldChange}
            />
          </Grid>

          {/* Customer Classification Section */}
          <Grid item xs={12}>
            <SectionTitle>Customer Classification</SectionTitle>
          </Grid>
          {/* Division */}
          <Grid item xs={12} md={6}>
            <SelectField
              label="Division"
              fieldKey="division"
              options={masterData.division}
              value={formData.division}
              onChange={handleFieldChange}
            />
          </Grid>

          {/* State */}
          <Grid item xs={12} md={6}>
            <SelectField
              label="State"
              fieldKey="state"
              options={masterData.state}
              value={formData.state}
              onChange={handleFieldChange}
            />
          </Grid>

          {/* Customer Class */}
          <Grid item xs={12} md={6}>
            <SelectField
              label="Customer Class"
              fieldKey="customer_class"
              options={masterData.customer_class}
              value={formData.customer_class}
              onChange={handleFieldChange}
            />
          </Grid>

          {/* Status */}
          <Grid item xs={12} md={6}>
            <SelectField
              label="Status"
              fieldKey="status"
              options={masterData.status}
              value={formData.status}
              onChange={handleFieldChange}
            />
          </Grid>

          {/* Price Group */}
          <Grid item xs={12} md={6}>
            <SelectField
              label="Price Group"
              fieldKey="price_group"
              options={masterData.price_group}
              value={formData.price_group}
              onChange={handleFieldChange}
            />
          </Grid>

          {/* Price List */}
          <Grid item xs={12} md={6}>
            <SelectField
              label="Price List"
              fieldKey="price_list"
              options={masterData.price_list}
              value={formData.price_list}
              onChange={handleFieldChange}
            />
          </Grid>

          {/* Address Section */}
          <Grid item xs={12}>
            <SectionTitle>Address</SectionTitle>
          </Grid>
          {/* Name1 */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Name1"
              fieldKey="name1"
              value={formData.name1.code}
              onChange={handleFieldChange}
            />
          </Grid>
          {/* Street/House No. */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Street/House No."
              fieldKey="street_house_no"
              value={formData.street_house_no.code}
              onChange={handleFieldChange}
            />
          </Grid>
          {/* C/O */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="C/O"
              fieldKey="care_of"
              value={formData.care_of.code}
              onChange={handleFieldChange}
            />
          </Grid>
          {/* Street 2 */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Street 2"
              fieldKey="street2"
              value={formData.street2.code}
              onChange={handleFieldChange}
            />
          </Grid>
          {/* Street 3 */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Street 3"
              fieldKey="street3"
              value={formData.street3.code}
              onChange={handleFieldChange}
            />
          </Grid>
          {/* Street 5 */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Street 5"
              fieldKey="street5"
              value={formData.street5.code}
              onChange={handleFieldChange}
            />
          </Grid>

          {/* Tyre Brand Selector (optional) */}
          {/* <Grid item xs={12} md={6}>
            <TyreBrandSelector
              selectedTyreGroups={selectedTyreGroups}
              onSelect={handleTyreGroupSelect}
            />
          </Grid> */}

          {/* Contact Section */}
          <Grid item xs={12}>
            <SectionTitle>Contact</SectionTitle>
          </Grid>
          {/* GST Number */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="GST Number"
              fieldKey="gst_number"
              value={formData.gst_number.code}
              onChange={handleFieldChange}
            />
          </Grid>

          {/* NIN Number */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="NIN Number"
              fieldKey="ninnumber"
              value={formData.ninnumber.code}
              onChange={handleFieldChange}
            />
          </Grid>

          {/* Contact Person */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Contact Person"
              fieldKey="contact_person"
              value={formData.contact_person.code}
              onChange={handleFieldChange}
            />
          </Grid>

          {/* Phone Number */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Phone Number"
              fieldKey="phone_number"
              value={formData.phone_number.code}
              onChange={handleFieldChange}
            />
          </Grid>

          {/* Email */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Email"
              fieldKey="email"
              type="email"
              value={formData.email.code}
              onChange={handleFieldChange}
            />
          </Grid>

          {/* Address */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Address"
              fieldKey="address"
              value={formData.address.code}
              onChange={handleFieldChange}
            />
          </Grid>

          {/* City */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="City"
              fieldKey="city"
              value={formData.city.code}
              onChange={handleFieldChange}
            />
          </Grid>

          {/* Postal Code */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Postal Code"
              fieldKey="postal_code"
              value={formData.postal_code.code}
              onChange={handleFieldChange}
            />
          </Grid>

          {/* Region */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Region"
              fieldKey="region"
              value={formData.region.code}
              onChange={handleFieldChange}
            />
          </Grid>
          {/* District */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="District"
              fieldKey="district"
              value={formData.district.code}
              onChange={handleFieldChange}
            />
          </Grid>
          {/* Different City */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Different City"
              fieldKey="different_city"
              value={formData.different_city.code}
              onChange={handleFieldChange}
            />
          </Grid>

          {/* Mobile Phone */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Mobile Phone"
              fieldKey="mobile_phone"
              value={formData.mobile_phone.code}
              onChange={handleFieldChange}
            />
          </Grid>
          {/* Telephone */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Telephone"
              fieldKey="telephone"
              value={formData.telephone.code}
              onChange={handleFieldChange}
            />
          </Grid>
          {/* FAX */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="FAX"
              fieldKey="fax"
              value={formData.fax.code}
              onChange={handleFieldChange}
            />
          </Grid>

          {/* Tax & Compliance Section */}
          <Grid item xs={12}>
            <SectionTitle>Tax &amp; Compliance</SectionTitle>
          </Grid>
          {/* Tax Number 3 */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Tax Number 3"
              fieldKey="tax_number_3"
              value={formData.tax_number_3.code}
              onChange={handleFieldChange}
            />
          </Grid>
          {/* PAN */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="PAN"
              fieldKey="pan"
              value={formData.pan.code}
              onChange={handleFieldChange}
            />
          </Grid>

          {/* Commercial Settings Section */}
          <Grid item xs={12}>
            <SectionTitle>Commercial Settings</SectionTitle>
          </Grid>
          {/* Customer Statistic Group */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Customer Statistic Group"
              fieldKey="customer_statistic_group"
              value={formData.customer_statistic_group.code}
              onChange={handleFieldChange}
            />
          </Grid>
          {/* Delivering Plant */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Delivering Plant"
              fieldKey="delivering_plant"
              value={formData.delivering_plant.code}
              onChange={handleFieldChange}
            />
          </Grid>
          {/* Rebate */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Rebate"
              fieldKey="rebate"
              value={formData.rebate.code}
              onChange={handleFieldChange}
            />
          </Grid>
          {/* GST and Non GST */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="GST and Non GST"
              fieldKey="gst_non_gst"
              value={formData.gst_non_gst.code}
              onChange={handleFieldChange}
            />
          </Grid>
          {/* Incoterms1 */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Incoterms1"
              fieldKey="incoterms1"
              value={formData.incoterms1.code}
              onChange={handleFieldChange}
            />
          </Grid>

          {/* Geo & Limits Section */}
          <Grid item xs={12}>
            <SectionTitle>Geo &amp; Limits</SectionTitle>
          </Grid>
          {/* Latitude */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Latitude"
              fieldKey="latitude"
              value={formData.latitude.code}
              onChange={handleFieldChange}
            />
          </Grid>

          {/* Longitude */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Longitude"
              fieldKey="longitude"
              value={formData.longitude.code}
              onChange={handleFieldChange}
            />
          </Grid>

          {/* Credit Limit */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Credit Limit"
              fieldKey="credit_limit"
              type="number"
              value={formData.credit_limit.code}
              onChange={handleFieldChange}
            />
          </Grid>

          {/* Account Manager */}
          <Grid item xs={12} md={6}>
            <TextFieldInput
              label="Account Manager"
              fieldKey="account_manager"
              value={formData.account_manager.code}
              onChange={handleFieldChange}
            />
          </Grid>
        </Grid>

        {/* Action Buttons */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          sx={{
            mt: 4,
            justifyContent: "flex-end",
            alignItems: { xs: "stretch", sm: "center" },
          }}
        >
          <Button variant="outlined" size="large" onClick={handleCancel}>
            Cancel
          </Button>
          <Button variant="contained" size="large" onClick={handleSubmit}>
            Submit
          </Button>
        </Stack>
      </SectionCard>
    </Container>
  );
};

export default DealerForm;




